module.exports = "<!--<lottie-animation-view [options]=\"config\" [width]=\"100\" [height]=\"100\"></lottie-animation-view>-->\n<div class=\"spinner\" #spinner></div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/spinner/spinner.component.html
// module chunks = 4